// Maatwerk: hard clampen van hoeveelheidsvelden op hun max-attribuut
function clampQuantityInput(input) {
	if (!input.hasAttribute('max')) return;
	var max = parseFloat(input.getAttribute('max'));
	var min = input.hasAttribute('min') ? parseFloat(input.getAttribute('min')) : 1;
	var value = parseFloat(input.value);
	if (isNaN(value)) return;
	if (value > max) {
		input.value = max;
	} else if (value < min) {
		input.value = min;
	}
}

document.addEventListener('input', function (e) {
	if (e.target.matches && e.target.matches('.input-amount input[type="number"][max]')) {
		clampQuantityInput(e.target);
	}
}, true);

document.addEventListener('submit', function (e) {
	var form = e.target;
	if (!form.querySelectorAll) return;
	var qtyInputs = form.querySelectorAll('input[type="number"][max]');
	Array.from(qtyInputs).forEach(clampQuantityInput);
}, true);

// Maatwerk: vendor-bestellimiet live synchroniseren met de actuele winkelwagen
// (nodig omdat add-to-cart via AJAX gaat en de pagina niet herlaadt)
function syncVendorLimits() {
	var vendorInputs = document.querySelectorAll('input[data-vendor-limit][data-vendor-product-id]');
	if (!vendorInputs.length) return;

	fetch('/cart.js')
		.then(function (res) { return res.json(); })
		.then(function (cart) {
			var qtyByProductId = {};
			cart.items.forEach(function (item) {
				qtyByProductId[item.product_id] = (qtyByProductId[item.product_id] || 0) + item.quantity;
			});

						vendorInputs.forEach(function (input) {
				var productId = parseFloat(input.getAttribute('data-vendor-product-id'));
				var limit = parseFloat(input.getAttribute('data-vendor-limit'));
				var qtyInCart = qtyByProductId[productId] || 0;
				var remaining = Math.max(limit - qtyInCart, 0);

				input.setAttribute('max', remaining);

				var form = input.closest('form');
				var submitButton = form && form.querySelector('button[type="submit"]');
				var buttonTextEl = submitButton && submitButton.querySelector('span');

				if (remaining <= 0) {
					input.value = 0;
					input.disabled = true;
					if (submitButton) {
						submitButton.disabled = true;
						submitButton.classList.add('disabled');
						if (!submitButton.hasAttribute('data-original-label') && buttonTextEl) {
							submitButton.setAttribute('data-original-label', buttonTextEl.textContent);
						}
						if (buttonTextEl) {
							buttonTextEl.textContent = 'Maximaal aantal bereikt';
						}
					}
				} else {
					input.disabled = false;
					if (submitButton) {
						submitButton.disabled = false;
						submitButton.classList.remove('disabled');
						if (submitButton.hasAttribute('data-original-label') && buttonTextEl) {
							buttonTextEl.textContent = submitButton.getAttribute('data-original-label');
						}
					}
					clampQuantityInput(input);
				}
			});
		})
		.catch(function () { /* stil falen; de server-side Liquid-max blijft als vangnet staan */ });
}

// Detecteer add-to-cart calls, ongeacht of het thema fetch of XHR gebruikt
(function () {
	var originalFetch = window.fetch;
	window.fetch = function () {
		var result = originalFetch.apply(this, arguments);
		var url = arguments[0];
		if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
			result.then(function () {
				setTimeout(syncVendorLimits, 150);
			});
		}
		return result;
	};

	var originalOpen = XMLHttpRequest.prototype.open;
	XMLHttpRequest.prototype.open = function (method, url) {
		if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
			this.addEventListener('loadend', function () {
				setTimeout(syncVendorLimits, 150);
			});
		}
		return originalOpen.apply(this, arguments);
	};
})();

document.addEventListener('DOMContentLoaded', syncVendorLimits);